<template>
  <sAlert
    small>
    {{ $t('Tenders.OriginalTender') }}
    <div>
      <router-link
        slot="desc"
        data-qa="tenderNumber"
        style="color: var(--alert-text-desc) !important;"
        target="_blank"
        :to="{name: 'tenderitem', params: { id: value.TenderId, org: value.OrganizationId}}">
        {{ `#${value.TenderNumber}. ${value.TenderSubject}` }}
      </router-link>
      <div
        v-if="hasBids || hasAttachments"
        class="mt-2">
        <div
          v-if="hasBids"
          data-qa="hasBids">
          {{ $t('Tenders.HistoryCopiedWithBids') }}
        </div>
        <div
          v-if="hasAttachments"
          data-qa="hasAttachments">
          {{ $t('Tenders.HistoryCopiedWithAttachments') }}
        </div>
      </div>
    </div>
  </sAlert>
</template>
<script>
export default {
  name: 'EventHistoryTenderCopiedParams',
  computed: {
    hasBids() {
      return !!this.value?.Bids?.length
    },
    hasAttachments() {
      return this.hasBids && this.value?.Bids?.some(bid => bid.CopyAttachments)
    }
  },
  props: {
    value: {
      type: Object
    }
  },
}
</script>
